import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! @glint-nocheck: not typesafe yet }}\n<div ...attributes>\n  {{yield}}\n</div>")